var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditLimitExhaustedImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 46,
    viewBox: "0 0 76 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000007391"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 6916",
    d: "M37.7572 0.824024L37.7465 0.53413L37.463 0.595849L7.36633 7.14916L7.36711 7.62365L37.9492 14.177L38.2542 14.2423L38.2427 13.9307L37.7572 0.824024Z",
    fill: "#E6864E",
    stroke: "#4F1212",
    strokeWidth: 0.485431
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 6915",
    d: "M37.9995 14.1824V14.4811L38.2919 14.4199L69.6022 7.8666L69.604 7.39184L38.2937 0.595816L37.9995 0.531958V0.833008V14.1824Z",
    fill: "#E6864E",
    stroke: "#4F1212",
    strokeWidth: 0.485431
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 6913",
    d: "M6.498 7.39155L6.20455 7.32883V7.62891V39.1819V39.3827L6.40177 39.4203L38.1975 45.4882L38.4857 45.5432V45.2498V14.4249V14.2286L38.2937 14.1876L6.498 7.39155Z",
    fill: "#E67240",
    stroke: "#4F1212",
    strokeWidth: 0.485431
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 6912",
    d: "M70.0379 7.62891V7.3306L69.7458 7.39126L38.1928 13.9446L37.9995 13.9847V14.1822V45.2498V45.5436L38.288 45.4881L69.841 39.4203L70.0379 39.3824V39.1819V7.62891Z",
    fill: "#E67240",
    stroke: "#4F1212",
    strokeWidth: 0.485431
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 6911",
    d: "M70.017 7.28814L69.9375 7.10927L69.7458 7.14907L38.1928 13.7024L37.896 13.764L38.0211 14.0402L43.8463 26.9041L43.9258 27.0798L44.115 27.0419L75.668 20.7313L75.9653 20.6719L75.8422 20.3948L70.017 7.28814Z",
    fill: "#E6864E",
    stroke: "#4F1212",
    strokeWidth: 0.485431
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 6914",
    d: "M32.3704 27.0421L32.5653 27.0805L32.6415 26.897L37.9812 14.0331L38.0934 13.7629L37.8072 13.7025L6.7396 7.14923L6.55338 7.10995L6.47082 7.28143L0.160219 20.3881L0.0240661 20.6708L0.332 20.7315L32.3704 27.0421Z",
    fill: "#E6864E",
    stroke: "#4F1212",
    strokeWidth: 0.485431
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditLimitExhaustedImg);
export default __webpack_public_path__ + "static/media/credit_limit_exhausted_img.ebb90b16807568df8636dc2f7e848158.svg";
export { ForwardRef as ReactComponent };